export const alti = {
  couleurPrincipale: '#f7a823',
  couleurSecondaire: '#083e66',
  couleurSecondaireGradient: '#083e66',
  couleurTertiaire: '#687943',
  fondGrisOpaque: '#b3b1b2',
  couleurPrincipaleHover: '#FBCDA4',
  couleurSecondaireHover: '#A2BEDD',
  couleurFond: '#FAFAFA',
  bordureGrise: '#BABBC1',
  couleurMenuToolbar: '#01233f',
  couleurOrangeTable: '#f5b061',
  couleurFontsUser: '#FFFFFF',
  couleurPoliceFonce: '#000000',
  couleurErreur: 'red',
};
